module.exports = __webpack_public_path__ + "static/succes-fd740f7a4f74ff7601475f490c5786fb.svg";